module.exports = __webpack_public_path__ + "static/media/feynlab-bottle.b7d70128.jpg";